import React from 'react';
import AboutStart from '../components/aboutStart/AboutStart';
import Members from '../components/members/Members';

const About = () => {
  return (
    <div>
      <AboutStart />
      <Members />
    </div>
  );
};

export default About;
